export enum WorksheetMode {
    STANDALONE,
    TEMPLATE,
    LINKED
}

/**
 * Workflow status values for TP Allocation worksheets and templates.
 *
 * Mirrors the backend enum `TPAllocationWorksheetStatus` in
 * ICTransferPricingDataAccess (com.amazon.ictpe.dataaccess.util.Constants),
 * which the WebAPILambda returns verbatim in the `status` field of
 * WorksheetDetail / WorksheetTemplateDetail. Only `ACTIVE` entities are
 * promotable to production.
 */
export enum TPAllocationStatus {
    ACTIVE = 'Active',
    DRAFT_IN_PROGRESS = 'Draft in Progress',
    INACTIVE = 'Inactive',
    PENDING_REVIEW = 'Pending Review'
}